import { render, staticRenderFns } from "./PurchaseinReportDetail.vue?vue&type=template&id=b78bc554"
import script from "./PurchaseinReportDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseinReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports